import { render, staticRenderFns } from "./BattlesGame.vue?vue&type=template&id=356feba8&scoped=true"
import script from "./BattlesGame.vue?vue&type=script&lang=js"
export * from "./BattlesGame.vue?vue&type=script&lang=js"
import style0 from "./BattlesGame.vue?vue&type=style&index=0&id=356feba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356feba8",
  null
  
)

export default component.exports